import { render, staticRenderFns } from "./DetailLianbaoCard.vue?vue&type=template&id=e9e6c2da&scoped=true&"
import script from "./DetailLianbaoCard.vue?vue&type=script&lang=js&"
export * from "./DetailLianbaoCard.vue?vue&type=script&lang=js&"
import style0 from "./DetailLianbaoCard.vue?vue&type=style&index=0&id=e9e6c2da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e6c2da",
  null
  
)

export default component.exports